export default {
  title: "Notifiche staff",
  description: "Avvisi operativi che richiedono attenzione dello staff.",
  empty: {
    title: "Nessuna notifica",
    description: "Non ci sono notifiche per i filtri selezionati.",
    openOnly: "Nessuna notifica aperta al momento.",
  },
  filters: {
    status: "Stato",
    severity: "Gravità",
    category: "Categoria",
    any: "Qualsiasi",
  },
  statusTabs: {
    open: "Aperte",
    acknowledged: "In carico",
    resolved: "Risolte",
    all: "Tutte",
  },
  status: {
    open: "Aperta",
    acknowledged: "Presa in carico",
    resolved: "Risolta",
  },
  severity: {
    warning: "Avviso",
    error: "Errore",
    critical: "Critica",
  },
  category: {
    payment: "Pagamento",
    booking: "Prenotazione",
    receipt: "Ricevuta",
    scheduler: "Scheduler",
    integration: "Integrazione",
    support: "Supporto",
    device: "Dispositivo",
    unknown: "Altro ({{value}})",
  },
  titles: {
    refund: {
      failed: "Rimborso fallito presso il provider",
      rejected_handshake_failed: "Rimborso per rifiuto handshake fallito",
      retry_exhausted:
        "Tentativi di rimborso esauriti — intervento manuale richiesto",
    },
    device: {
      low_battery: "Batteria scarica: {{displayLabel}} ({{batteryLevel}}%)",
      low_battery_kiosk: "Batteria scarica: Tablet {{kioskName}}",
      low_battery_kiosk_at_house: "Batteria scarica: Tablet {{kioskName}} in {{houseName}}",
      low_battery_reader: "Batteria scarica: Lettore POS",
      low_battery_reader_at_house:
        "Batteria scarica: Lettore POS in {{houseName}}, collegato al kiosk {{kioskName}}",
      low_battery_reader_linked:
        "Batteria scarica: Lettore POS collegato al kiosk {{kioskName}}",
      low_battery_reader_at_house_only: "Batteria scarica: Lettore POS in {{houseName}}",
    },
    booking: {
      created: "{{activityName}} — {{customerName}}",
      receipt: {
        manual_amount_registered: "Importo ricevuta manuale registrato dal partner",
      },
    },
    handshake: {
      notification_exhausted: "Notifiche handshake iniziali non consegnate",
      message_blocked: "Messaggio handshake bloccato",
    },
    support: {
      ticket: {
        created: "Nuovo ticket di supporto ({{ticketNumber}})",
        partner_message: "Risposta partner sul ticket {{ticketNumber}}",
        notification_failed: "Notifica ticket fallita ({{ticketNumber}})",
      },
    },
    customer_support: {
      chat: {
        message: "Messaggio chat supporto clienti",
      },
    },
    test: {
      receipt: {
        warning: "[dev] Avviso di test ricevuta",
      },
      refund: {
        failed: "[dev] Rimborso fallito presso il provider",
      },
      manual: "Avviso di test",
    },
  },
  eventTypes: {
    refund: {
      failed: "Rimborso fallito",
      rejected_handshake_failed: "Rimborso per rifiuto handshake fallito",
      retry_exhausted: "Tentativi di rimborso esauriti",
    },
    device: {
      low_battery: "Batteria scarica",
    },
    booking: {
      created: "Nuova prenotazione creata",
      receipt: {
        manual_amount_registered: "Importo ricevuta manuale registrato",
      },
    },
    handshake: {
      notification_exhausted: "Notifiche handshake non consegnate",
      message_blocked: "Messaggio handshake bloccato",
    },
    support: {
      ticket: {
        created: "Nuovo ticket di supporto",
        partner_message: "Risposta partner su ticket",
        notification_failed: "Notifica ticket fallita",
      },
    },
    customer_support: {
      chat: {
        message: "Messaggio chat supporto clienti",
      },
    },
    test: {
      receipt: {
        warning: "Avviso ricevuta di test",
      },
      refund: {
        failed: "Rimborso di test fallito",
      },
      manual: "Notifica manuale di test",
    },
  },
  targetTypes: {
    booking: "Prenotazione",
    external_payment: "Pagamento esterno",
    handshake_session: "Sessione handshake",
    support_ticket: "Ticket di supporto",
    customer_support_chat: "Chat supporto clienti",
    device: "Dispositivo",
    reader: "Lettore",
  },
  details: {
    eventType: "Evento",
    serialNumber: "Numero di serie",
    target: "Target",
    lastOccurred: "Ultima occorrenza",
  },
  occurrences: "{{count}} occorrenze",
  groups: {
    today: "Oggi",
    yesterday: "Ieri",
    older: "Precedenti",
  },
  audit: {
    acknowledged: "Presa in carico da {{admin}} il {{date}}",
    resolved: "Risolta da {{admin}} il {{date}}",
    unknownAdmin: "Staff sconosciuto",
  },
  card: {
    expand: "Espandi notifica: {{title}}",
    collapse: "Comprimi notifica: {{title}}",
  },
  bulk: {
    selectAll: "Seleziona tutte in pagina",
    selectOne: "Seleziona {{title}}",
    selected: "{{count}} selezionate",
    pageCount: "{{count}} in pagina",
    hint: "Seleziona più notifiche e prendile in carico o risolvile insieme",
    clearSelection: "Deseleziona",
    acknowledge: "Prendi in carico",
    resolve: "Risolvi",
    acknowledgeSuccess: "{{count}} notifiche prese in carico",
    resolveSuccess: "{{count}} notifiche risolte",
    partialError: "{{count}} azioni fallite",
  },
  actions: {
    openPayment: "Apri pagamento",
    openBooking: "Apri prenotazione",
    openHandshake: "Apri handshake",
    openTicket: "Apri ticket",
    openChat: "Apri chat",
    openDevice: "Vai al dispositivo",
    openStructure: "Vai alla struttura",
    noLinks: "Nessuna risorsa collegata",
    acknowledge: "Prendi in carico",
    resolve: "Risolvi",
    reopen: "Riapri",
    acknowledgeSuccess: "Notifica presa in carico",
    resolveSuccess: "Notifica risolta",
    reopenSuccess: "Notifica riaperta",
    acknowledgeError: "Impossibile prendere in carico",
    resolveError: "Impossibile risolvere",
    reopenError: "Impossibile riaprire",
  },
  pagination: "Pagina {{page}} di {{totalPages}} ({{total}} totali)",
  paginationSingle_one: "{{count}} notifica",
  paginationSingle_other: "{{count}} notifiche",
} as const;
